/* Wishlist feature - localStorage + UI */
(function () {
  var KEY = "sq_wishlist_v1";
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (e) { return []; } }
  function save(arr) { localStorage.setItem(KEY, JSON.stringify(arr)); window.dispatchEvent(new CustomEvent("sq:wishlist:change")); }
  function has(handle) { return load().some(function (i) { return i.handle === handle; }); }
  function toggle(item) { var list = load(); var idx = list.findIndex(function (i) { return i.handle === item.handle; }); if (idx >= 0) list.splice(idx, 1); else list.unshift(item); save(list); return idx < 0; }
  function remove(handle) { save(load().filter(function (i) { return i.handle !== handle; })); }
  var SVG_HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7-4.35-9.5-9C1 8.5 3.5 4.5 7.5 4.5c2 0 3.5 1 4.5 2.5 1-1.5 2.5-2.5 4.5-2.5 4 0 6.5 4 5 7.5C19 16.65 12 21 12 21z"/></svg>';
  function getCount() { return load().length; }
  function buildHeaderTrigger() {
    if (document.querySelector(".sq-header-wishlist")) return;
    var cart = document.querySelector('#cart-link, .cart-icon--bubble, a[href*="/cart"]:not(.button--outline)'); if (cart) { var pCart = cart.closest('.hdr-st-item') || cart.parentElement; if (pCart && pCart.parentElement) { cart = pCart; } }
    if (!cart) return;
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "sq-wishlist-trigger sq-header-wishlist";
    btn.setAttribute("aria-label", "Open wishlist");
    btn.innerHTML = SVG_HEART + '<span class="sq-wishlist-count">0</span>';
    cart.parentNode.insertBefore(btn, cart);
    btn.addEventListener("click", function (e) { e.preventDefault(); openDrawer(); });
  }
  function updateHeader() {
    var n = getCount();
    document.querySelectorAll(".sq-header-wishlist").forEach(function (b) {
      b.classList.toggle("has-items", n > 0);
      var c = b.querySelector(".sq-wishlist-count"); if (c) c.textContent = String(n);
    });
  }
  function buildPdpButton() {
    if (document.querySelector(".sq-pdp-wishlist")) return;
    var atcRow = document.querySelector(".product-form__buttons");
    if (!atcRow) return;
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "sq-wishlist-trigger sq-pdp-wishlist";
    btn.setAttribute("aria-label", "Add to wishlist");
    btn.innerHTML = SVG_HEART;
    atcRow.appendChild(btn);
    var handle = getCurrentProductHandle();
    if (handle && has(handle)) btn.classList.add("is-active");
    btn.addEventListener("click", function () {
      var item = getCurrentProductSummary();
      if (!item) return;
      var added = toggle(item);
      btn.classList.toggle("is-active", added);
    });
  }
  function getCurrentProductHandle() { var m = location.pathname.match(/\/products\/([^/?]+)/); return m ? m[1] : null; }
  function getCurrentProductSummary() {
    var handle = getCurrentProductHandle(); if (!handle) return null;
    var titleEl = document.querySelector(".product__title, h1.product__title, h1");
    var imgEl = document.querySelector(".product-main-media-section img, .product__media img");
    var priceEl = document.querySelector(".price__regular .price-item, .price-item--regular, [class*='price-item']");
    return { handle: handle, title: titleEl ? (titleEl.textContent || "").trim() : handle, url: "/products/" + handle, image: imgEl ? imgEl.currentSrc || imgEl.src : null, price: priceEl ? (priceEl.textContent || "").trim() : "" };
  }
  function buildDrawer() {
    if (document.querySelector(".sq-wishlist-drawer")) return;
    var backdrop = document.createElement("div");
    backdrop.className = "sq-wishlist-backdrop";
    backdrop.addEventListener("click", closeDrawer);
    document.body.appendChild(backdrop);
    var d = document.createElement("aside");
    d.className = "sq-wishlist-drawer";
    d.innerHTML = '<div class="sq-wishlist-drawer__head"><h3 class="sq-wishlist-drawer__title">My Wishlist</h3><button type="button" class="sq-wishlist-drawer__close" aria-label="Close">&times;</button></div><div class="sq-wishlist-drawer__body"></div>';
    document.body.appendChild(d);
    d.querySelector(".sq-wishlist-drawer__close").addEventListener("click", closeDrawer);
  }
  function renderDrawer() {
    var body = document.querySelector(".sq-wishlist-drawer__body");
    if (!body) return;
    var list = load();
    if (!list.length) { body.innerHTML = '<div class="sq-wishlist-drawer__empty">Your wishlist is empty.<br>Tap the heart next to Add to Bag to save your favorites.</div>'; return; }
    body.innerHTML = list.map(function (it) { return '<div class="sq-wishlist-item" data-handle="' + it.handle + '"><a href="' + it.url + '"><img src="' + (it.image || "") + '" alt="'+ (it.title || "") + '"></a><a href="' + it.url + '"><div>' + (it.title || "") + '</div><div>' + (it.price || "") + '</div></a><button type="button" class="sq-wishlist-item__remove" aria-label="Remove">&times;</button></div>'; }).join("");
    body.querySelectorAll(".sq-wishlist-item__remove").forEach(function (b) { b.addEventListener("click", function () { var item = b.closest(".sq-wishlist-item"); remove(item.dataset.handle); renderDrawer(); }); });
  }
  function openDrawer() { buildDrawer(); renderDrawer(); document.querySelector(".sq-wishlist-drawer").classList.add("is-open"); document.querySelector(".sq-wishlist-backdrop").classList.add("is-open"); }
  function closeDrawer() { document.querySelector(".sq-wishlist-drawer").classList.remove("is-open"); document.querySelector(".sq-wishlist-backdrop").classList.remove("is-open"); }
  function init() { buildHeaderTrigger(); buildPdpButton(); updateHeader(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  window.addEventListener("sq:wishlist:change", function () { updateHeader(); renderDrawer(); });
  window.addEventListener("storage", function (e) { if (e.key === KEY) { updateHeader(); renderDrawer(); } });
})();
